import styled from "styled-components";

export const StyledResult = styled.p`
  font-size: 19px;
  word-break: break-word;
  min-height: 28.5px;
`;
